import LayoutSettings from '@/components/LayoutSetting/LayoutSettings';
import { isEmpty } from '@/helpers';
import {
  handleSaveShippingSettings,
  shippingSettingSelector
} from '@/redux/slice/shipping.slice';
import { BlockStack, Button, InlineStack, Tag, TextField } from '@shopify/polaris';
import { PlusIcon } from '@shopify/polaris-icons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const ShippingTags = () => {
  const { t } = useTranslation('shippingSettings');
  const shippingSettings = useSelector(shippingSettingSelector);
  const dispatch = useDispatch();
  const [valueTags, setValueTags] = useState<string>('');

  const handleAddTags = () => {
    if (!isEmpty(valueTags.trim())) {
      if (shippingSettings.additionalTags) {
        dispatch(handleSaveShippingSettings({ additionalTags: [...shippingSettings.additionalTags, valueTags] }));
      } else {
        dispatch(handleSaveShippingSettings({ additionalTags: [valueTags] }));
      }
      setValueTags('');
    }
  };

  const handleRemoveTag = (index: number) => {
    const listTags = shippingSettings.additionalTags;
    const newListTags = listTags?.filter((_, idx) => idx !== index);
    dispatch(handleSaveShippingSettings({ additionalTags: [...newListTags] }));
  };

  return (
    <LayoutSettings title={t('shippingTags.shippingTags')} helpText={t('shippingTags.shippingTagsDesc')}>
      <BlockStack gap={'100'}>
        <TextField
          label={t('shippingTags.attachTags')}
          placeholder="Shipping"
          value={valueTags}
          onChange={(value: string) => setValueTags(value)}
          autoComplete="off"
          connectedRight={
            <Button onClick={handleAddTags} icon={PlusIcon} disabled={isEmpty(valueTags.trim())}>
              {t('shippingTags.addTags')}
            </Button>
          }
        />
        {shippingSettings.additionalTags.length > 0 && (
          <InlineStack gap={'100'}>
            {shippingSettings.additionalTags.map((item, index) => (
              <Tag key={`tag--${index}`} onRemove={() => handleRemoveTag(index)}>
                {item}
              </Tag>
            ))}
          </InlineStack>
        )}
      </BlockStack>
    </LayoutSettings>
  );
};

export default ShippingTags;
